import http from './http'

class Tenant {
  fetch () {
    return http.get('/admin_back_office/tenant_representatives')
  }

  reset (payload) {
    return http.post('/reset_tenant', { password: payload })
  }
}

export default new Tenant()



// WEBPACK FOOTER //
// ./src/services/tenant.js